<div fxLayout="row" style="width: 100%; padding: 6px 0">
  <div class="shortcut-width" fxLayout="row" fxLayoutAlign="end start">
    @if (hotkey.modifier) {
      <div class="keyboard-key modifier-key">{{ hotkey.modifier | uppercase }}</div>
      <div>&nbsp;&nbsp;+&nbsp;</div>
      <div class="keyboard-key">
        {{ hotkey.key | uppercase }}
      </div>
    } @else {
      <div class="keyboard-key">{{ hotkey.key | uppercase }}</div>
    }
  </div>
  <div style="margin-left: 16px">{{ hotkey.description }}</div>
</div>
